import { Box, Flex } from "../cores";

type TIconCo2 = {
  value: string;
};
const IconCo2 = ({ value }: TIconCo2) => {
  const co2 = value.split("|");
  return (
    <Flex
      sx={{ justifyContent: "center", alignItems: "center", height: "100%" }}
    >
      <Box
        as={"span"}
        sx={{
          height: "auto",
          backgroundColor:
            co2[0] === "iu" || co2.length === 1
              ? "none"
              : co2[1] === "1"
              ? "green"
              : "red",
          color: co2[0] === "iu" || co2.length === 1 ? "black" : "white",
          borderRadius: "5px",
          paddingY: co2[0] === "iu" || co2.length === 1 ? 0 : "2px",
          fontWeight: co2[0] === "iu" || co2.length === 1 ? 0 : 600,
          minWidth: "40px",
          maxWidth: "40px",
          boxShadow:
            co2[0] === "iu" || co2.length === 1
              ? "none"
              : "0px 2px 5px -1px rgb(50 50 93 / 25%), 0px 1px 3px -1px rgb(0 0 0 / 30%)",
        }}
      >
        {co2[0] ? co2[0] : null}
      </Box>
    </Flex>
  );
};

export default IconCo2;
